export function FactTableRowComponent($compile) {
  return {
    restrict  : 'A',
    scope     : {
      filter   : '=',
      fact     : '=',
      showImage: '=',
      listType : '=',
      select   : '=',
    },
    controller: function ($scope, $element) {
    },
    link      : function (scope, element, attrs) {
//                 scope.viewMode = getTableViewByType(scope.filter.viewModeType(), scope.filter.filters);
      scope.viewMode = scope.$parent.viewMode;
      let widget = scope.viewMode.columns.map((colView, c) => {
        let table = element.parent();
        while(table && table[0].nodeName.toLowerCase() !== 'sc-facts-table') {
          table = table[0] === document.body ? null : table.parent();
        }
        if (!table) {
          return;
        }
        let thSelector = table.find('.fact-table th:visible');
        let th = thSelector[c];
        let setWidth = th ? getComputedStyle(th).width : 0;
        return '<td class="' + (colView['cssClass'] ? colView['cssClass'] : '') +
          ' rc-' + c + '" style="width: ' + setWidth + '">' +
          colView.parse(scope.fact, 'short') + '</td>';
      }).join('', '');
      element.append(widget);
      $compile(element.contents())(scope);
    },
  };
}



// WEBPACK FOOTER //
// ./src/facts/fact-table-row.component.js